export interface PostalCodeResult {
  prefecture: string
  city: string
  town: string
}

export interface PostalCodeResponse {
  status: number
  message: string | null
  results: Array<{
    zipcode: string
    prefcode: string
    address1: string
    address2: string
    address3: string
  }> | null
}

export async function searchPostalCode(postalCode: string): Promise<PostalCodeResult | null> {
  const cleaned = postalCode.replace(/-/g, '')
  if (!/^\d{7}$/.test(cleaned)) {
    return null
  }

  const response = await fetch(`https://zipcloud.ibsnet.co.jp/api/search?zipcode=${cleaned}`)
  if (!response.ok) {
    return null
  }
  const data: PostalCodeResponse = await response.json()

  if (data.status !== 200 || !data.results || data.results.length === 0) {
    return null
  }

  const result = data.results[0]
  return {
    prefecture: result.address1,
    city: result.address2,
    town: result.address3,
  }
}
